import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  TextArea,
  Dropdown,
  Checkbox
} from 'semantic-ui-react'

const CardDentistCertificateUX = (props: any) => {
    return(
      <div>
        <Form
          id="CardDentistCertificateUX-Form-1">
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-2"
            style={{display: "flex", padding: "1rem 0rem 0rem 1rem"}}>
            <label
              id="CardDentistCertificateUX-label-3">
              {props.languageUX === "en" ? "Diagnosis" : "การวินิจฉัย"}
            </label>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-5"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <TextArea
              disabled={props.isCopied}
              id="CardDentistCertificateUX-TextArea-4"
              name="diagnosis"
              onChange={props.onChangeData}
              rows="15"
              style={{marginLeft: "1rem"}}
              value={props.dentistReport?.diagnosis || ""}>
            </TextArea>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-6"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <label
              id="CardDentistCertificateUX-label-10">
              {props.languageUX === "en" ? "Treatment provided" : "การรักษาที่ให้"}
            </label>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-7"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <TextArea
              disabled={props.isCopied}
              id="CardDentistCertificateUX-TextArea-12"
              name="treatment"
              onChange={props.onChangeData}
              rows="15"
              style={{marginLeft: "1rem"}}
              value={props.dentistReport?.treatment || ""}>
            </TextArea>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-8"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <label
              id="CardDentistCertificateUX-label-11">
              {props.languageUX === "en" ? "Dentist Opinion" : "ความคิดเห็นทันตแพทย์"}
            </label>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-9"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <TextArea
              disabled={props.isCopied}
              id="CardDentistCertificateUX-TextArea-13"
              name="detail"
              onChange={props.onChangeData}
              rows="15"
              style={{marginLeft: "1rem"}}
              value={props.dentistReport?.detail || ""}>
            </TextArea>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-14"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <label
              id="CardDentistCertificateUX-label-19">
              {props.languageUX === "en" ? "Physician listed on certificate" : "แพทย์ที่แสดงในใบรับรอง"}
            </label>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-15"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <Dropdown
              clearable={true}
              disabled={props.isCopied}
              id="CardDentistCertificateUX-Dropdown-20"
              name="doctor"
              onChange={props.onChangeData}
              options={props.doctorList || []}
              search={true}
              selection={true}
              style={{marginLeft: "1rem", minWidth: "22rem"}}
              value={props.dentistReport?.doctor}>
            </Dropdown>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-16"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <Checkbox
              checked={props.dentistReport?.is_pediatric_dentists}
              disabled={props.isCopied}
              id="CardDentistCertificateUX-Checkbox-24"
              label={props.languageUX === "en" ? "Dental student" : "นักศึกษาทันตแพทย์"}
              name="is_pediatric_dentists"
              onChange={props.onChangeData}
              style={{marginLeft: "2rem"}}>
            </Checkbox>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-17"
            style={{display: "flex", padding: "0rem 0rem 0rem 1rem"}}>
            <Dropdown
              clearable={true}
              disabled={!props.dentistReport?.is_pediatric_dentists || props.isCopied}
              id="CardDentistCertificateUX-Dropdown-22"
              name="pediatric_dentists"
              onChange={props.onChangeData}
              options={props.doctorList || []}
              search={true}
              selection={true}
              style={{marginLeft: "1rem", minWidth: "22rem"}}
              value={props.dentistReport?.pediatric_dentists}>
            </Dropdown>
          </FormGroup>
          <FormGroup
            className="ui form"
            id="CardDentistCertificateUX-FormGroup-18"
            style={{display: "flex", justifyContent: "flex-end"}}>
            <div
              id="CardDentistCertificateUX-div-23">
              {props.onCloseSelected}
            </div>
          </FormGroup>
        </Form>
      </div>
    )
}


export default CardDentistCertificateUX

export const screenPropsDefault = {}

/* Date Time : Fri Sep 05 2025 16:51:42 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"1rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "การวินิจฉัย",
          "valueEN": "Diagnosis"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-label-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "TextArea",
      "parent": 5,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isCopied"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-TextArea-4"
        },
        "name": {
          "type": "value",
          "value": "diagnosis"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "15"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.dentistReport?.diagnosis || \"\""
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-6"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-8"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-9"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "การรักษาที่ให้",
          "valueEN": "Treatment provided"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-label-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ความคิดเห็นทันตแพทย์",
          "valueEN": "Dentist Opinion"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-label-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "TextArea",
      "parent": 7,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isCopied"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-TextArea-12"
        },
        "name": {
          "type": "value",
          "value": "treatment"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "15"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.dentistReport?.treatment || \"\""
        }
      },
      "seq": 12,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "TextArea",
      "parent": 9,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isCopied"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-TextArea-13"
        },
        "name": {
          "type": "value",
          "value": "detail"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "rows": {
          "type": "value",
          "value": "15"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.dentistReport?.detail || \"\""
        }
      },
      "seq": 13,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-14"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-15"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-16"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-17"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding: \"0rem 0rem 0rem 1rem\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-FormGroup-18"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ที่แสดงในใบรับรอง",
          "valueEN": "Physician listed on certificate"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-label-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Dropdown",
      "parent": 15,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.isCopied"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-Dropdown-20"
        },
        "name": {
          "type": "value",
          "value": "doctor"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.doctorList || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\", minWidth: \"22rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.dentistReport?.doctor"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Dropdown",
      "parent": 17,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.dentistReport?.is_pediatric_dentists || props.isCopied"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-Dropdown-22"
        },
        "name": {
          "type": "value",
          "value": "pediatric_dentists"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.doctorList || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\", minWidth: \"22rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.dentistReport?.pediatric_dentists"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.onCloseSelected"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-div-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Checkbox",
      "parent": 16,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.dentistReport?.is_pediatric_dentists"
        },
        "disabled": {
          "type": "code",
          "value": "props.isCopied"
        },
        "id": {
          "type": "value",
          "value": "CardDentistCertificateUX-Checkbox-24"
        },
        "label": {
          "type": "value",
          "value": "นักศึกษาทันตแพทย์",
          "valueEN": "Dental student"
        },
        "name": {
          "type": "value",
          "value": "is_pediatric_dentists"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"2rem\"}"
        }
      },
      "seq": 24,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardDentistCertificateUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
